
const digest = '186923ad02a421495073fff8d50a71c8580dc5966149020d2aa400daee7ffc01';
const classes = {"wrapper":"_wrapper_1v9le_1"};
const css = `._wrapper_1v9le_1 {
  display: flex;
  flex-direction: column;
  background: #fbfbfd;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  